// Avena cocoa advertorial runtime. Self-hosted; no third-party requests. Cart uses the theme's native drawer.
(() => {
  function init(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    const cfg = {
      adding: root.dataset.adding, added: root.dataset.added, error: root.dataset.error,
      added_fallback: root.dataset.addedFallback, unavailable: root.dataset.unavailable
    };

    // Reading progress bar (source behavior: fills as the article scrolls).
    const fill = root.querySelector('.reading-progress-fill');
    const progress = () => {
      if (!fill) return;
      const range = root.scrollHeight - innerHeight;
      fill.style.width = Math.max(0, Math.min(100, range > 0 ? (scrollY - root.offsetTop) / range * 100 : 0)) + '%';
    };
    addEventListener('scroll', progress, { passive: true });
    progress();

    // Urgency timer. Source restarted a 14:59 countdown on every load; this one persists per visitor
    // (evergreen) or counts to a fixed deadline, and pulses in the final minute.
    const timer = root.querySelector('[data-acm-timer]');
    if (timer) {
      const mode = root.dataset.timerMode || 'evergreen';
      const minutes = Math.max(1, parseInt(root.dataset.timerMinutes || '15', 10));
      const key = root.dataset.timerKey || 'acm-timer';
      let deadline = NaN;
      if (mode === 'deadline') {
        deadline = Date.parse(root.dataset.timerDeadline || '');
      } else {
        try {
          const saved = parseInt(localStorage.getItem(key) || '', 10);
          if (Number.isFinite(saved) && saved > Date.now() && saved - Date.now() <= minutes * 60000) deadline = saved;
          else { deadline = Date.now() + minutes * 60000; localStorage.setItem(key, String(deadline)); }
        } catch (e) { deadline = Date.now() + minutes * 60000; }
      }
      const pad = (n) => String(n).padStart(2, '0');
      const tick = () => {
        if (!Number.isFinite(deadline)) { timer.textContent = '-- : --'; return; }
        const remaining = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
        if (remaining === 0) { timer.textContent = root.dataset.timerExpired || '00 : 00'; timer.classList.add('is-expired'); return; }
        const h = Math.floor(remaining / 3600), m = Math.floor(remaining % 3600 / 60), s = remaining % 60;
        timer.textContent = (h ? pad(h) + ' : ' : '') + pad(m) + ' : ' + pad(s);
        timer.classList.toggle('is-urgent', remaining <= 60);
      };
      tick();
      if (Number.isFinite(deadline)) {
        const id = setInterval(() => { if (!root.isConnected) { clearInterval(id); return; } tick(); }, 1000);
      }
    }

    // Buy box: radio offers, hero image follows the selected offer, quantity is always 1.
    const form = root.querySelector('.acm-form');
    if (form) {
      const button = root.querySelector('.acm-submit'), status = root.querySelector('.acm-status'), fallback = root.querySelector('.acm-fallback');
      const label = button.querySelector('span'), original = label.textContent;
      const hero = root.querySelector('[data-acm-offer-image]');
      let pending = false;
      const selected = () => form.querySelector('[name=id]:checked:not(:disabled)');
      const swapImage = () => {
        const option = selected()?.closest('[data-acm-offer]');
        if (!hero || !option) return;
        if (option.dataset.acmImage) hero.src = option.dataset.acmImage;
        hero.alt = option.dataset.acmLabel || '';
      };
      const update = () => { button.disabled = pending || !selected(); swapImage(); };
      form.addEventListener('change', update);
      update();
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        if (pending) return;
        if (!selected()) { status.hidden = false; status.textContent = cfg.unavailable; return; }
        const id = Number(selected().value), quantity = 1;
        if (!Number.isSafeInteger(id)) return;
        pending = true; update(); label.textContent = cfg.adding; status.hidden = true; fallback.hidden = true; button.setAttribute('aria-busy', 'true');
        const drawer = document.querySelector('cart-drawer');
        let added = false;
        try {
          drawer?.setActiveElement?.(button);
          const sections = drawer?.getSectionsToRender?.().map((s) => s.id) || ['cart-drawer', 'cart-icon-bubble'];
          const r = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id, quantity }], sections, sections_url: location.pathname })
          });
          if (!/^(application\/json|text\/javascript)(;|$)/i.test(r.headers.get('content-type') || '')) throw new Error(cfg.error);
          const data = await r.json();
          if (!r.ok || data.status >= 400) throw new Error(data.description || cfg.error);
          added = true;
          if (!drawer?.renderContents || sections.some((k) => !data.sections?.[k])) throw new Error(cfg.added_fallback);
          drawer.classList.remove('is-empty');
          drawer.renderContents(data);
          status.textContent = cfg.added;
        } catch (error) {
          status.textContent = added ? cfg.added_fallback : (error.message || cfg.error);
          fallback.hidden = !added;
        } finally {
          status.hidden = false; pending = false; label.textContent = original; button.removeAttribute('aria-busy'); update();
        }
      });
    }

    // Inline offer card (round 3): same add-to-cart contract as the main buy box, fixed 8-bottle variant.
    root.querySelectorAll('[data-acm-inline-add]').forEach((button) => {
      const card = button.closest('.acm-inline-card');
      const status = card?.querySelector('.acm-inline-status');
      const label = button.querySelector('.cta-btn-main');
      const original = label.textContent;
      let pending = false;
      button.addEventListener('click', async () => {
        if (pending) return;
        const id = Number(button.dataset.acmInlineAdd);
        if (!Number.isSafeInteger(id)) return;
        pending = true; button.disabled = true; label.textContent = cfg.adding;
        if (status) status.hidden = true;
        const drawer = document.querySelector('cart-drawer');
        let added = false;
        try {
          drawer?.setActiveElement?.(button);
          const sections = drawer?.getSectionsToRender?.().map((s) => s.id) || ['cart-drawer', 'cart-icon-bubble'];
          const r = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id, quantity: 1 }], sections, sections_url: location.pathname })
          });
          if (!/^(application\/json|text\/javascript)(;|$)/i.test(r.headers.get('content-type') || '')) throw new Error(cfg.error);
          const data = await r.json();
          if (!r.ok || data.status >= 400) throw new Error(data.description || cfg.error);
          added = true;
          if (!drawer?.renderContents || sections.some((k) => !data.sections?.[k])) throw new Error(cfg.added_fallback);
          drawer.classList.remove('is-empty');
          drawer.renderContents(data);
          if (status) status.textContent = cfg.added;
        } catch (error) {
          if (status) status.textContent = added ? cfg.added_fallback : (error.message || cfg.error);
        } finally {
          if (status) status.hidden = false;
          pending = false; button.disabled = false; label.textContent = original;
        }
      });
    });

    // Clinicians' Choice widget (cloned UI; hidden unless enabled in the editor).
    const floating = root.querySelector('.acm-clinician-floating'), badge = root.querySelector('#acm-clinician-badge');
    if (floating && badge && !badge.hidden) {
      const watch = new IntersectionObserver((entries) => { floating.hidden = entries[0].isIntersecting; });
      watch.observe(badge);
    }
    const directory = root.querySelector('.acm-directory-dialog'), profile = root.querySelector('.acm-profile-dialog');
    if (directory && profile) {
      const list = directory.querySelector('.fr-provider-list-section');
      root.querySelectorAll('[data-acm-provider-slot]').forEach((slot) => { list.append(slot.querySelector('.fr-provider-list-item')); slot.remove(); });
      let opener = null, profileOpener = null, oldOverflow = '';
      const closeAll = () => { profile.close(); directory.close(); document.body.style.overflow = oldOverflow; opener?.focus(); };
      const back = () => { profile.close(); profileOpener?.focus(); };
      root.querySelectorAll('[data-acm-proof-open]').forEach((b) => b.addEventListener('click', () => { opener = b; oldOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden'; directory.showModal(); }));
      directory.querySelector('[data-acm-widget-back]').addEventListener('click', closeAll);
      profile.querySelector('[data-acm-widget-back]').addEventListener('click', back);
      [directory, profile].forEach((d) => {
        d.querySelector('[data-acm-widget-close]').addEventListener('click', closeAll);
        d.addEventListener('cancel', (e) => { e.preventDefault(); closeAll(); });
        d.addEventListener('click', (e) => { if (e.target === d) closeAll(); });
        d.addEventListener('keydown', (e) => {
          if (e.key !== 'Tab') return;
          const nodes = [...d.querySelectorAll('button,a[href],summary,input')].filter((n) => n.getClientRects().length);
          const first = nodes[0], last = nodes.at(-1);
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        });
      });
      directory.querySelectorAll('details').forEach((item) => item.addEventListener('toggle', () => { if (item.open) directory.querySelectorAll('details').forEach((other) => { if (other !== item) other.open = false; }); }));
      const configuredLink = (a) => { try { const raw = a.getAttribute('href') || ''; const url = new URL(raw, location.href); return raw && !raw.startsWith('#') && ['https:', 'http:'].includes(url.protocol); } catch { return false; } };
      const openProfile = (button, preview = false) => {
        const row = button.closest('[data-acm-provider-row]'); profileOpener = button;
        const website = row.querySelector('[data-acm-field=website]');
        profile.querySelector('[data-acm-website-open]').setAttribute('href', website?.getAttribute('href') || '#acm-preview');
        profile.querySelector('.fr-doctor-title').textContent = row.querySelector('.fr-provider-name > div > span').textContent;
        row.querySelectorAll('[data-acm-field]').forEach((field) => {
          if (field.dataset.acmField === 'website') return;
          const target = profile.querySelector('dd.' + field.dataset.acmField);
          if (target) target.textContent = field.textContent;
        });
        const portrait = row.querySelector('figure img'); const images = profile.querySelector('.images');
        images.querySelectorAll('img').forEach((i) => i.remove()); images.classList.toggle('mural-placeholder', !portrait);
        if (portrait) images.append(portrait.cloneNode(true));
        profile.querySelector('[data-acm-preview-status]').hidden = !preview;
        profile.showModal(); profile.querySelector('.fr-modal-content').scrollTop = 0;
      };
      directory.querySelectorAll('[data-acm-profile-open]').forEach((b) => b.addEventListener('click', () => openProfile(b)));
      directory.querySelectorAll('[data-acm-preview-open]').forEach((b) => b.addEventListener('click', (e) => { if (configuredLink(b)) { b.target = '_blank'; b.rel = 'noopener noreferrer'; return; } e.preventDefault(); openProfile(b, true); }));
      profile.querySelector('[data-acm-website-open]').addEventListener('click', (e) => { if (configuredLink(e.currentTarget)) { e.currentTarget.target = '_blank'; e.currentTarget.rel = 'noopener noreferrer'; return; } e.preventDefault(); profile.querySelector('[data-acm-preview-status]').hidden = false; profile.querySelector('.fr-modal-content').scrollTop = 0; });
      directory.querySelectorAll('[data-acm-directory-open]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); list.scrollIntoView({ block: 'start' }); list.querySelector('button')?.focus({ preventScroll: true }); }));
    }
  }
  document.querySelectorAll('.qp').forEach(init);
  document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll('.qp').forEach(init));
})();
